// Singleton bridge so non-hook code (e.g. aiService) can reach the global JobContext.
// JobProvider populates this on mount via setJobRegistrar().

let _registerJob = null;

export function setJobRegistrar(registerFn) {
  _registerJob = registerFn;
}

/**
 * Try to register a job with the global context.
 * Returns the Promise<result> from the context, or null if the context is not yet mounted.
 */
export function tryRegisterJob(jobId, label = 'AI Processing…', meta = {}) {
  if (_registerJob) {
    return _registerJob(jobId, label, meta);
  }
  return null;
}
